module.exports = __webpack_public_path__ + "img/biking.33bda1bb.png";